module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-warning-box"
  }, [_c('div', {
    staticClass: "u-d-flex"
  }, [_c('icons'), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.toggleModal
    }
  }, [_vm._t("icon")], 2), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex"
  }, [_c('div', {
    on: {
      "click": _vm.toggleModal
    }
  }, [_vm._t("b")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0baebaf3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/WarningBox.vue
// module id = 1566
// module chunks = 0